var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.tag,{tag:"component",staticClass:"row",class:[_vm.alignment, _vm.alignContents, _vm.justifyContents, {'gx-0': _vm.noGutters, 'gx-16': _vm.dense}]},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }